import React from 'react';

import roundNumber from '../../../utils/roundNumber';

interface PercentageLabelsProps {
    innerEdge: number;
    outerEdge: number;
    fontSize: number;
    percentageLabelAngle: number;
    multiplicationRatio?: number;
}

const PercentageLabels = ({ innerEdge, outerEdge, fontSize, percentageLabelAngle, multiplicationRatio = 1 }: PercentageLabelsProps) => {
    const length = outerEdge - innerEdge;
    const textStyle = { fontSize: `${fontSize * 0.9}%`, fill: 'black', stroke: 'white', strokeWidth: 3, paintOrder: 'stroke' };
    const lastTextStyle = { fontSize: `${fontSize * 0.9}%`, fill: 'currentColor' };

    return (
        <g>
            {Array.from({ length: 5 }).map((_, i, a) => {
                const radius = innerEdge + ((i + 1) / 5) * length;
                const percentage = (((i + 1) / 5) * 100) / multiplicationRatio;
                const percentageRounded = multiplicationRatio === 1 ? percentage : roundNumber({ num: percentage, dp: 2 });

                return (
                    <g key={i}>
                        <circle fill='none' stroke='#16161d' strokeDasharray='8,8' r={radius} />
                        <text transform={`rotate(${percentageLabelAngle}) translate(0, -${radius + 5})`} style={i === a.length - 1 ? lastTextStyle : textStyle}>
                            {percentageRounded}%
                        </text>
                    </g>
                );
            })}
        </g>
    );
};

export default PercentageLabels;
